import React from 'react';
import Logo from '../../../assets/images/RC_Logo.svg'
import LogoWhite from '../../../assets/images/RC_Logo_White.svg'
import './style.scoped.scss';

const RegCityLogo = ({ smallerLogo, isPlans }) => {
  return (
    <div id="RegCity_Logo" className={smallerLogo ? 'smaller' : null}>
      <img alt="RegCity Logo" src={isPlans ? LogoWhite : Logo} />
    </div>
  );
};

export default RegCityLogo;
